export default __webpack_public_path__ + "b17de6bcf902418c485407dcf330a76a.svg";